import groupBy from 'lodash.groupby';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectEntities } from 'services/entities/selectors';
import { AppState } from 'services/types';
import { Props } from './index';
import { FertilizerEntityOptions } from '../FertilizerSchemaInnerEntityOptions/types';

const selectOptions = (
    state: AppState,
    props: Props
): FertilizerEntityOptions => props.options;

const selectFilteredOptions = createDeepEqualSelector(
    selectEntities,
    selectOptions,
    (entities, options) =>
        options.filter((entityOption) => {
            if (entities && entities[entityOption.value]) {
                const { totalArea } = entities[entityOption.value];

                return !!totalArea;
            }

            return false;
        })
);

const makeSelectFilteredOptions = (): typeof selectFilteredOptions =>
    selectFilteredOptions;

const selectInnerEntityIds = createDeepEqualSelector(
    selectFilteredOptions,
    (options) => options.map((option) => option.value)
);

const makeSelectInnerEntityIds = (): typeof selectInnerEntityIds =>
    selectInnerEntityIds;

const selectInnerEntitiesGroupedByVariety = createDeepEqualSelector(
    selectFilteredOptions,
    (options) =>
        groupBy(options, (option) => option.varietyName || 'Uncategorized')
);

const makeSelectInnerEntitiesGroupedByVariety =
    (): typeof selectInnerEntitiesGroupedByVariety =>
        selectInnerEntitiesGroupedByVariety;

export {
    makeSelectFilteredOptions,
    makeSelectInnerEntityIds,
    makeSelectInnerEntitiesGroupedByVariety
};
